export default __webpack_public_path__ + "static/media/Allsorts_Summer-Activity-Poster.cc2872dd.jpg";